window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  init: function() {

    var _this = this;
    var selectors = {
      boxId: '[data-box-id]',
      productId: '[data-product-id]',
      cartTableRow: '.c-table__row',
      removeBox: '[data-remove-box]',
      updateBox: '[data-update-box]',
      editBox: '[data-edit-box]',
      cartPopupClose: '[data-cart-popup-close]',
    };

    _this.removeBox(selectors);
    _this.updateBox(selectors);
    _this.closeCartPopup(selectors);
  },


  /**
   * Remove box products from cart
   *
   */
  removeBox: function(selectors) {
    $(selectors.removeBox).click(function(e) {
      e.preventDefault();
      var boxId = $(this).attr('data-box-id');
      var updateArray = [];
      var parent = $(this).closest('table');
      $(selectors.productId, parent).each(function() {
        if($(this).attr('data-box-id') == boxId) {
          updateArray.push(0);
        } else {
          if($('.c-field__input--qty', $(this))) {
            var currentQty = $('.c-field__input--qty', $(this)).val();
          } else {
            var currentQty = 1;
          }
          updateArray.push(currentQty);
        }
      });
      var data = {
        updates: updateArray
      }
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(response) {
          // Redirect to cart after updating
          document.location.href = "/cart";
        },
        error: function(response) {
          console.log(response);
          alert("Something went wrong. We could not remove this box.");
        }
      });
    });
  },


  /**
   * Update box products quantities
   *
   */
  updateBox: function(selectors) {
    $(selectors.updateBox).click(function(e) {
      e.preventDefault();
      var boxId = $(this).attr('data-box-id');
      var boxSize = $(this).attr('data-box-size');
      var updateQty = $(this).siblings('.c-field__input--qty').val();
      var updateArray = [];
      var parent = $(this).closest('table');
      var firstProductFlag = 1;
      var currentBoxQty;
      $(selectors.productId, parent).each(function() {
        if($(this).attr('data-box-id') == boxId) {
          if(firstProductFlag == 1) {
            currentBoxQty = $('.c-field__input--qty', $(this)).val();
            updateArray.push(updateQty);
            firstProductFlag = 0;
          } else {
            var currentProductQty = $('.c-field__input--qty', $(this)).val();
            var baseProductQty = (currentProductQty / currentBoxQty);
            updateArray.push(baseProductQty * updateQty);
          }
        } else {
          if($('.c-field__input--qty', $(this))) {
            var currentQty = $('.c-field__input--qty', $(this)).val();
          } else {
            var currentQty = 1;
          }
          updateArray.push(currentQty);
        }
      });
      var data = {
        updates: updateArray
      }
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(response) {
          // Redirect to cart after updating
          document.location.href = "/cart";
        },
        error: function(response) {
          console.log(response);
          alert("Something went wrong. We could not update this box.");
        }
      });
    });
  },

  /**
   * Update Cart Popup List Item
   *
   */
  updateCartPopup: function(product, qtyToAdd) {
    $('[data-cart-popup-items]').html(
      '<li class="c-cart-popup__item">' +
        '<div class="c-cart-popup__item-image-wrap">' +
          '<img src="' + product.image + '" alt="' + product.product_title + '">' +
          '<div class="c-cart-popup__item-qty">' + qtyToAdd + '</div>' +
        '</div>' +
        '<div class="c-cart-popup__item-content">' +
          '<h3 class="c-cart-popup__item-title">' + product.product_title + '</h3>' +
          '<div class="c-cart-popup__item-properties">' +
            (product.variant_title != null ? product.variant_title + ' <span class="c-cart-popup__item-properties-divider">|</span> ': '') +
            'Price: <span class="hulkapps-cart-item-price" data-key="'+product.key+'">' + slate.Currency.formatMoney(product.price, theme.moneyFormat) +
          '</span></div>' +
        '</div>' +
      '</li>'
    );
    // Update count in utility nav
    $('[data-cart-items-count]').html(parseInt(qtyToAdd) + parseInt($('[data-cart-items-count]').html()));
  },

  /**
   * Toggle Cart Popup
   *
   */
  toggleCartPopup: function(selectors) {
    if($('[data-cart-popup]').hasClass("hide")) {
      $('[data-cart-popup]').removeClass("hide");
      $('[data-cart-popup-overlay]').removeClass("hide");
    } else {
      $('[data-cart-popup]').addClass("hide");
      $('[data-cart-popup-overlay]').addClass("hide");
    }
  },

  /**
   * Click event for cart popup close icon
   *
   */
  closeCartPopup: function(selectors) {
    $(selectors.cartPopupClose).on('click', function(evt) {
      slate.cart.toggleCartPopup();
    });
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   * Get value from query string paramter
   *
   * @param {*} sParam - string parameter
   * @returns {*} - Returns the resolved value
   */
  getUrlParameter: function(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  },

};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.c-rte table').wrap('<div class="c-rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.c-rte iframe[src*="youtube.com/embed"], .c-rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.c-rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="c-rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

/**
 * Modal
 * -----------------------------------------------------------------------------
 *
 * @namespace modal
 */

slate.modal = {

  /**
   * Toggles modal
   *
   */

  toggleModal: function() {
    $('[data-modal]').toggleClass('is-open');
  },

};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var temp = this.$container;
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.name = $element.attr('name');
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            $('[data-button-variant]').removeClass("is-active");
            $element.parent().addClass("is-active");
            $('[data-button-label]').html(currentOption.value);
            
            if (currentOption.name == 'color' || currentOption.name == 'colour') {
              temp.trigger({
                type: 'variantColorChange',
                color: currentOption.value
              });
            }

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      if(this.currentVariant) {
        var currentVariantImage = this.currentVariant.featured_image || {};
      } else {
        var currentVariantImage = null;
      }

      // if (!variant.featured_image || !currentVariantImage || variantImage.src === currentVariantImage.src) {
      //   return;
      // }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (!this.currentVariant || (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price)) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * BAB Callout Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the BabCallout section.
 *
   * @namespace BabCallout
 */

theme.BabCallout = (function() {

  var selectors = {
    babBucket1: '[data-bab-bucket-1]',
    babBucket2: '[data-bab-bucket-2]',
  };

  /**
   * BabCallout section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function BabCallout(container) {
    this.$container = $(container);

    $(selectors.babBucket1).hover(
      function() {
        $(selectors.babBucket2).removeClass('is-active');
        $(this).addClass('is-active');
      },
      function() {
        return;
      }
    )

    $(selectors.babBucket2).hover(
      function() {
        $(selectors.babBucket1).removeClass('is-active');
        $(this).addClass('is-active');
      },
      function() {
        $(this).removeClass('is-active');
        $(selectors.babBucket1).addClass('is-active');
      }
    );
  }

  BabCallout.prototype = $.extend({}, BabCallout.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return BabCallout;
})();

/**
 * Build A Box Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Build A Box template.
 *
   * @namespace buildabox
 */

theme.Buildabox = (function() {
  var selectors = {
    qtyToAdd: '[data-qty-to-add]',
    addToBox: '[data-add-to-box]',
    addToCart: '[data-add-to-cart]',
    addToCartFixed: '.u-bab-hide-on-full[data-add-to-cart]',
    boxSummary: '[data-box-summary]',
    boxSummaryDetails: '[data-box-summary] .o-well--bab',
    boxItems: '[data-box-items]',
    boxItem: '[data-box-item]',
    boxPrice: '#c-bab-summary__price',
    boxCount: '[data-box-count]',
    boxTotalCount: '[data-box-total-count]',
    boxIndicator: '[data-box-indicator]',
    emptyBox: '[data-empty-box]',
    removeFromBox: '[data-remove-from-box]',
    qtyPopup: '[data-qty-popup]',
    toggleQtyPopup: '[data-toggle-qty-popup]',
    updateBoxItemQty: '[data-update-box-item-qty]',
    updateboxItemQtyText: '[data-update-box-item-qty-text]',
    updateboxItemQtyInput: '[data-update-box-item-qty-input]',
    product: '[data-product]',
    productJson: '[data-product-json]',
    productId: '[data-product-id]',
    productHandle: '[data-product-handle]',
    productPrice: '[data-product-price]',
    productTitle: '[data-product-title]',
    productSaleBanner: '[data-sale-banner]',
    toggleBoxSize: '[data-toggle-box-size]',
    variantId: '[data-variant-id]',
    singleOptionSelector: '[data-single-option-selector]',
    babProduct: '[data-bab-product]',
    babProductTitle: '[data-bab-product-title]',
    packSizeSelector: '[data-pack-size-selector]',
    updateProductPrice: '[data-update-product-price]',
    updateComparePrice: '[data-update-compare-price]',
    mobileBox: '.c-bab-summary--mobile',
    mobileBoxContainer: '.c-bab-summary--mobile__container',
    pageTitle: '.c-page-title',
    sectionDropdownButton: '.c-accordion--bab .c-accordion__btn',
  };


  /**
   * Buildabox section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Buildabox(container) {
    this.$container = $(container);
    productsToUpdate = [];
    productsToAdd = [];

    // Populate box if we have a query string, add each key/value to array.
    this.loadHistoryState();

    $(selectors.toggleBoxSize).on('click', this.toggleBoxSize.bind(this));
    $(selectors.addToCart).on('click', this.addToCart.bind(this));
    $(selectors.addToBox).on('click', this.addToBox.bind(this));
    $(selectors.emptyBox).on('click', this.triggerEmptyBox.bind(this));
    $(selectors.singleOptionSelector).on('change', this._onSelectChange.bind(this));
    $(document).on('click', selectors.removeFromBox, this.removeFromBox.bind(this));
    $(document).on('click', selectors.toggleQtyPopup, this.toggleQtyPopup.bind(this));
    $(document).on('click', selectors.updateBoxItemQty, this.updateBoxItemQty.bind(this));

    //Mobile
    $(selectors.mobileBox).on('click', this.displayMobileSummary.bind(this));
    $(selectors.pageTitle).on('click', this.hideMobileSummary.bind(this));

    $(selectors.sectionDropdownButton).on('click', this.scrollToDropdown);


    /*
    // Box Items Counter Functionality //
    new input qty containers might be added
    */
    $(document).on('click', '.c-field__input--qty--container', this.quantityButtonClicked.bind(this));

    // // Make sidebar sticky
    // No longer needed - sticky setting is done in scss
    // $(selectors.boxSummary).stickybits({
    //   useStickyClasses: true,
    //   stickyBitStickyOffset: 85
    // });


    //---------------------Mobile Setup-----------------------//

    
    const pageTitle = $(selectors.pageTitle);
    this.originalPageTitleText = pageTitle.text();
  }

  Buildabox.prototype = $.extend({}, Buildabox.prototype, {

    /**
     * Add product to the BAB Summary items
     *
     */
    addToCart: function(evt) {
      // This changes the id of the bab everytime the add to bag button is pressed. This prevents boxes already in cart from getting overwritten
      this.updateHistoryState("id", Math.floor(100000000 + Math.random() * 900000000));

      // Loop through all box items
      var self = this;
      $(selectors.boxItem).each(function() {
        var parent = $(this);
        var productTitle = $(selectors.productTitle, parent).html();
        var productId = $(this).attr('data-product-id');
        var quantity = parseInt($(selectors.updateboxItemQtyText, parent).html());
        // Add them to the array
        self.updateProductArray(productsToAdd, productId, quantity);
      });

      // COMMENTED THIS OUT BECAUSE IT WAS NOT ACTUALLY UPDATING THE CART - IT NOW JUST ADDS THE BOX TO THE CART NOT MATTER HOW IT WAS ADDED
      //If we have items to update
      // if(productsToUpdate.length) {
      //   $.ajax({
      //     type: 'GET',
      //     url: '/cart.js',
      //     dataType: 'json',
      //     success: function(response) {
      //       console.log(response);
      //       findLineItems(response);
      //     },
      //     error: function(response) {
      //       console.log(response);
      //       moveAlong();
      //     }
      //   });
      //   function findLineItems(response) {
      //     var urlString = "";
      //     console.log(productsToUpdate);
      //     if(response) {
      //       for(var x = 0; x < productsToUpdate.length; x++) {
      //         // alert(productsToUpdate[x].id);
      //         for(var i = 0; i < response.items.length; i++) {
      //           if(response.items[i].properties.length) {
      //             if(response.items[i].properties[0] == productsToUpdate[x].id) {
      //               // alert(productsToUpdate[x].variantId + " " + productsToUpdate[x].quantity);
      //               urlString += 'updates[' + productsToUpdate[x].id + ']=' + productsToUpdate[x].quantity + '&';
      //             }
      //           }
      //         }
      //       }
      //     }
      //     // alert(urlString);
      //     $.post('/cart/update.js', urlString);
      //   }
      // } else {
        addBoxItems();
      // }

      function addBoxItems() {
        if(productsToAdd.length) {
          var request = productsToAdd.shift();
          var data = {
            id: request.variantId,
            quantity: request.quantity,
            properties: {
              'Box ID': request.id
            }
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() {
              console.log("item added to cart");
              addBoxItems();
            },
            error: function() {
              console.log("failed");
              addBoxItems();
            }
          });
        } else {
          addBabProduct();
        }
      }

      function addBabProduct() {
        var babType = self.$container.attr('data-bab-type') + " " + slate.utils.getUrlParameter("size") + " Pack";
        var babProductId = self.$container.attr('data-bab-product');
        if(babProductId) {
          var boxId = slate.utils.getUrlParameter("id");
          var data = {
            id: babProductId,
            quantity: 1,
            properties: {
              'Box ID': boxId,
              'Type': babType
            }
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() {
              // Send to cart page when done adding products
              document.location.href = '/cart';
            },
            error: function() {
              console.log("failed to add bab product");
            }
          });
        }
      }
    },

    /**
     * Add product to the BAB Summary items
     *
     */
    addToBox: function(evt) {
      var productHandle = evt.target.attributes['data-product-handle'].value;
      var parent = evt.target.closest('[data-product]');
      var qtyToAdd = parseInt($(selectors.qtyToAdd, parent).val());
      var currentBoxCount = parseInt($(selectors.boxCount).html());
      var updatedBoxCount = currentBoxCount + qtyToAdd;
      var currentBoxTotalCount = parseInt($(selectors.boxTotalCount).html());
      var currentBoxPrice = parseInt($(selectors.boxPrice).attr('data-box-price'));
      var product = JSON.parse($(selectors.productJson, parent).html());
      var variant = this._getVariantFromOptions(parent, product);
      var currentBoxSize = $('.c-btn--pack-size-active input').val();

      // Reset product's qty field to 1 after click
      $(selectors.qtyToAdd, parent).val(1);

      // If quantity to add is greater than 0
      if(qtyToAdd > 0) {

        // If the box isn't full, let's update the box summary
        if(updatedBoxCount <= currentBoxTotalCount) {

          // If product is already in the box, let's update the qty and url.
          // If not, then prepend it to the line items.
          if($(selectors.boxItems).has('[data-product-id="' + variant.id + '"]').size() > 0) {
            var parent = $(selectors.boxItems).find('[data-product-id="' + variant.id + '"]').first();
            var currentQuantity = parseInt($(selectors.updateboxItemQtyText, parent).html());
            // Update quantity text
            this.updateBoxItemQtyText(evt, parent, currentQuantity + qtyToAdd);
            // Update url
            this.updateHistoryState(variant.id, currentQuantity + qtyToAdd);
          } else {
            this.addBoxItem(product, qtyToAdd, variant);
          }

          // Update Box Summary Count
          this.updateBoxSummaryCount(updatedBoxCount);

          // Update Box Summary Fill Indicator
          this.updateBoxSummaryFillIndicator(updatedBoxCount, currentBoxTotalCount);

          // Update Box Summary Price
          var priceToAdd = qtyToAdd * variant.price;
          this.updateBoxSummaryPrice(currentBoxPrice + priceToAdd);

          // Check full status
          this.checkFullStatus(updatedBoxCount, currentBoxTotalCount);

        } else {

          alert("Your box is full!");
          return false;

        }

      }
    },

    /**
     * Add box item in the BAB Summary
     *
     */
    addBoxItem: function(product, qtyToAdd, variant) {
      if(product.featured_image != null) {
        var productImage = '<img src="' + product.featured_image + '" class="c-bab-summary__item-image" alt="' + product.title + '">';
      } else {
        var productImage = '<svg class="c-placeholder c-placeholder--bab" width="100%" height="100%"></svg>';
      }
      $(selectors.boxItems).prepend(
        '<li class="c-bab-summary__item" data-box-item data-product-id="' + variant.id + '" data-product-price="' + product.price + '">' +
          '<div class="c-bab-summary__item-image-wrap">' +
            productImage +
            '<div class="c-bab-summary__item-qty" data-update-box-item-qty-text>' + qtyToAdd + '</div>' +
          '</div>' +
          '<div class="c-bab-summary__item-content">' +
            '<h3 class="c-bab-summary__item-title" data-product-title>' + product.title + '</h3>' +
            '<div class="c-bab-summary__item-properties">' + variant.title + ' <span class="c-bab-summary__item-properties-divider">|</span> Price: ' + slate.Currency.formatMoney(variant.price, theme.moneyFormat) + '</div>' +
            '<div class="c-bab-summary__item-actions">' +
              '<button role ="button" class="c-bab-summary__item-update" data-toggle-qty-popup data-product-id="' + variant.id + '">Edit Quantity</button> <button role="button" class="c-bab-summary__item-remove" data-remove-from-box data-product-id="' + variant.id + '">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="c-bab-summary__qty-popup hide" data-qty-popup>'+
            '<button role="button" class="c-bab-summary__qty-popup-close" data-toggle-qty-popup data-product-id="' + variant.id + '">x</button>' +
            '<div class="c-bab-summary__qty-popup-inner">' +
              '<label class="c-bab-summary__qty-popup-label" for="updates_' + variant.id + '">Quantity</label>' +
              '<div class="c-field__input--qty--container">' + 
                '<input type="number" class="c-field__input--qty c-bab-summary__qty-popup-input" name="updates[]" id="updates_' + variant.id + '" value="' + qtyToAdd + '" min="1" data-update-box-item-qty-input data-qty-to-add>' +
                '<button class="c-field__input--qty--plus" aria-label="Increase Quantity"></button>' + 
                '<button class="c-field__input--qty--minus" aria-label="Decrease Quantity"></button>' + 
              '</div>' + 
              '<button role="button" class="c-btn" data-product-id="' + variant.id + '" data-update-box-item-qty>Update</button>' +
            '</div>' +
          '<div>' +
        '</li>'
      );

      // Update url
      this.updateHistoryState(variant.id, qtyToAdd);
    },

    
    /**
     * Box Item List clicked - find if event target was a quantity incrementer, and then update input quantity
     *
     */
    quantityButtonClicked: function(evt) {
      if (evt.target.classList.contains('c-field__input--qty--plus') || evt.target.classList.contains('c-field__input--qty--minus')) {
        
        evt.preventDefault();
        evt.stopPropagation();

        const input = evt.target.parentElement.querySelector('input[type="number"]');
        
        if (!input) return;
        
        if (evt.target.classList.contains('c-field__input--qty--plus')) {
            input.value ++;
            if (input.max && input.value > input.max) input.value = input.max;
        }

        if (evt.target.classList.contains('c-field__input--qty--minus')) {
            input.value --;
            if (input.min && input.value < input.min) input.value = input.min;          
        }

      }
    },

    displayMobileSummary: function(evt) {
      if (window.innerWidth >= 950) return;
      if(!$(selectors.mobileBox).hasClass('active')) return;
    
      // scroll up to reveal page title
      $('html, body').animate({
        scrollTop: $(".c-breadcrumb").offset().top
      }, 300);        

      
      //set container height based on active col
      const colContainer = $('.o-bab-columns-container');
      colContainer.addClass('notransition');
      colContainer.css('height', $('.o-columns__col--content').height());

      window.setTimeout( () => {
        
        //set active status
        $(selectors.mobileBox).removeClass('active');
        $('.o-columns--bab').addClass('active');
        $(selectors.addToCartFixed).addClass('inactive');

        
        $(selectors.mobileBox).one('webkitTransitionEnd oTransitionEnd msTransitionEnd transitionend', () => {
          $(selectors.mobileBoxContainer).css('visibility', 'hidden');
        });

          
        //change page title text
        $(selectors.pageTitle).addClass('c-page-title--bab');
        $(selectors.pageTitle).text('Your Box');
        
        const pageTitleArrow = document.createElement('span');
        pageTitleArrow.classList.add('c-page-title__arrow');
        $(selectors.pageTitle).append(pageTitleArrow);

      }, 100);

      window.setTimeout(() => {
        //set new container height

        colContainer.removeClass('notransition');
        colContainer.css('height', $('.o-columns__col--sidebar').height());
      }, 200);

    },

    hideMobileSummary: function(evt) {
      if (window.innerWidth >= 950) return;
      if($(selectors.mobileBox).hasClass('active')) return;

      //make mobile container visible
      $(selectors.mobileBoxContainer).css('visibility', 'visible');

      //set active status
      $(selectors.mobileBox).addClass('active');
      $('.o-columns--bab').removeClass('active');
      $(selectors.addToCartFixed).removeClass('inactive');

      //set container height based on active col
      const colContainer = $('.o-bab-columns-container');
      colContainer.css('height', $('.o-columns__col--content').height());
      colContainer.one('webkitTransitionEnd oTransitionEnd msTransitionEnd transitionend', () => {
        colContainer.css('height', '');
      });
      
      //change page title text
      $(selectors.pageTitle).removeClass('c-page-title--bab');
      $(selectors.pageTitle).html(this.originalPageTitleText);
    },


    /**
     * Update box item qty and in turn update the box summary
     *
     */
    updateBoxItemQty: function(evt, parent, currentQuantity, qtyToAdd) {
      var id = evt.target.attributes['data-product-id'].value;
      var parent = $(selectors.boxItem + '[data-product-id="' + id + '"]');
      var productPrice = parseInt($(parent).attr('data-product-price'));
      var currentQty = parseInt($(selectors.updateboxItemQtyText, parent).html());
      var qtyToAdjust = parseInt($(selectors.updateboxItemQtyInput, parent).val());
      var currentBoxCount = parseInt($(selectors.boxCount).html());
      var currentBoxTotalCount = parseInt($(selectors.boxTotalCount).html());
      var currentBoxPrice = parseInt($(selectors.boxPrice).attr('data-box-price'));
      var priceToAdjust = qtyToAdjust * productPrice;
      var updatedBoxCount = (currentBoxCount - currentQty) + qtyToAdjust;
      var updatedBoxSummaryPrice = (currentBoxPrice - (currentQty * productPrice)) + priceToAdjust;

      if(updatedBoxCount < 0) {
        alert('Quantity cannot be negative')
      }
      else {
      // If the box isn't full, let's update the box summary
        if(updatedBoxCount <= currentBoxTotalCount) {
          // Update Box Summary Count
          this.updateBoxSummaryCount(updatedBoxCount);

          // Update Box Summary Fill Indicator
          this.updateBoxSummaryFillIndicator(updatedBoxCount, currentBoxTotalCount);

          // Update Box Summary Price
          this.updateBoxSummaryPrice(updatedBoxSummaryPrice);

          // Update Box Item Quantities
          this.updateBoxItemQtyText(evt, parent, qtyToAdjust);

          // Hide Qty Popup
          this.toggleQtyPopup(evt);

          // Update url
          this.updateHistoryState(id, qtyToAdjust);

          // Update ToUpdate Product Array
          this.updateProductArray(productsToUpdate, id, qtyToAdjust);

          // Check full status
          this.checkFullStatus(updatedBoxCount, currentBoxTotalCount);
        } else {

          alert("Your box is full!");

          // Update Box Item Quantities
          this.updateBoxItemQtyText(evt, parent, currentQty);
          return false;

        }
      }
    },

    /**
     * Update box item qty text
     *
     */
    updateBoxItemQtyText: function(evt, parent, updatedBoxItemValue) {
      $(selectors.updateboxItemQtyText, parent).html(updatedBoxItemValue);
      $(selectors.updateboxItemQtyInput, parent).val(updatedBoxItemValue);
    },

    /**
     * Update box summary items count
     *
     */
    updateBoxSummaryCount: function(updatedBoxCount) {
      $(selectors.boxCount).html(updatedBoxCount);
    },

    /**
     * Update box summary fill indicator
     *
     */
    updateBoxSummaryFillIndicator: function(updatedBoxCount, currentBoxTotalCount) {
      var fillPercentage = (updatedBoxCount / currentBoxTotalCount) * 100;
      if(fillPercentage >= 100) {
        var fillPercentage = 100;
      }
      $(selectors.boxIndicator).width(fillPercentage + "%");
    },

    /**
     * Update box summary fill indicator
     *
     */
    updateBoxSummaryPrice: function(updatedBoxPrice) {
      var formattedBoxPrice = slate.Currency.formatMoney(updatedBoxPrice, theme.moneyFormat);
      $(selectors.boxPrice).attr('data-box-price', updatedBoxPrice).html(formattedBoxPrice);
    },

    /**
     * Update any of the product arrays
     *
     */
    updateProductArray: function(array, productId, quantity) {
      var babType = this.$container.attr('data-bab-type') + " " + slate.utils.getUrlParameter("size") + " Pack";
      var babUrl = (location.pathname + location.search).substr(1);
      var babId = slate.utils.getUrlParameter("id");

      array.push({
        variantId: productId,
        quantity: quantity,
        id: babId,
        type: babType
      });
    },

    /**
     * Update DOM to reflect product prices
     *
     */
    updatePrices: function(updatedBoxSize) {
      var self = this;
      $(selectors.product).each(function() {
        var parent = $(this);
        var product = JSON.parse($(selectors.productJson, parent).html());
        var variant = self._getVariantFromOptions(parent, product);
        var $productPrice = $(selectors.updateProductPrice, parent);
        var $comparePrice = $(selectors.updateComparePrice, parent);
        var $saleBanner = $(selectors.productSaleBanner, parent);
        if(variant.compare_at_price > variant.price) {
          $saleBanner.show();
          $productPrice.addClass('c-price__product-price--sale-bab').html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
          $comparePrice.show().html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        } else {
          $saleBanner.hide();
          $productPrice.removeClass('c-price__product-price--sale-bab').html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
          $comparePrice.hide().html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        }
      });
    },

    /**
     * Update DOM to select appropropriate Choose Your Pack variant
     *
     */
    updatePackSizeSelector: function(updatedBoxSize) {
      $(selectors.packSizeSelector).val(updatedBoxSize + 'pk - bab');
    },

    /**
     * Update url with select products and quantities
     *
     */
    updateHistoryState: function(key, value) {
      var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
          urlQueryString = document.location.search,
          newParam = key + '=' + value,
          params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (urlQueryString) {
          var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
          var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

          if( typeof value == 'undefined' || value == null || value == '' || value == '0' ) { // Remove param if value is empty
              params = urlQueryString.replace(removeRegex, "$1");
              params = params.replace( /[&;]$/, "" );

          } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
              params = urlQueryString.replace(updateRegex, "$1" + newParam);

          } else { // Otherwise, add it to end of query string
              params = urlQueryString + '&' + newParam;
          }
      }

      // no parameter was set so we don't need the question mark
      params = params == '?' ? '' : params;
      var newurl = baseUrl + params;
      window.history.replaceState({path: newurl}, "", newurl);
    },

    /**
     * Refresh BAB summary if we have a query string on load
     *
     */
    loadHistoryState: function(evt) {
      location.queryString = {};
      var qtyToAdd = 0;
      var priceToAdd = parseInt($(selectors.boxPrice).attr('data-box-price'));
      var currentBoxTotalCount = slate.utils.getUrlParameter("size") ?? $(selectors.toggleBoxSize).last().val();

      location.search.substr(1).split("&").forEach(function(pair) {
        // If query string is empty
        if(pair === "") {
          // Let's assign the box a random ID and the size
          var randomId = Math.floor(100000000 + Math.random() * 900000000);
          this.$container.attr('data-box-id', randomId);
          // Update box id
          this.updateHistoryState("id", randomId);
          // Update box size
          this.updateHistoryState("size", $(selectors.toggleBoxSize + ':checked').val());
          return false;
        } else if(!slate.utils.getUrlParameter("id")) {
          // Let's assign the box a random ID and the size
          var randomId = Math.floor(100000000 + Math.random() * 900000000);
          this.$container.attr('data-box-id', randomId);
          // Update box id
          this.updateHistoryState("id", randomId);
        }

        // Get query string parts
        var parts = pair.split("=");
        location.queryString[parts[0]] = parts[1] && decodeURIComponent(parts[1].replace(/\+/g, " "));

        if(parts[0] != "id") {
          // Find Product Object with Variant ID
          var self = this;
          var productArray = new Array();

          $(selectors.productJson).each(function() {
            var isContains = $(this).text().indexOf(parts[0]) > -1;
            if(isContains == true) {
              // Found the product JSON, so let's add it
              var parent = $(this).parent(selectors.product);
              var product = JSON.parse($(this).html());
              var variant = self._getVariantFromOptions(parent, product);

              // If an essentials product already added, skip it
              if (productArray.includes(product.id)) {
                // empty statement
              } else {
                qtyToAdd += parseInt(parts[1]);
                priceToAdd += parseInt(parts[1]) * variant.price;
                self.addBoxItem(product, parseInt(parts[1]), variant);
              }

              // Track the product ids already iterated
              productArray.push(product.id);
            }
          });

          // Update Box Summary Total Count
          $(selectors.boxTotalCount).html(currentBoxTotalCount);

          // Make box size button active
          $(selectors.toggleBoxSize).removeAttr("checked").parent('label').removeClass("c-btn--pack-size-active");
          $(selectors.toggleBoxSize + '[value=' + currentBoxTotalCount + ']').attr("checked", "checked").parent('label').addClass("c-btn--pack-size-active");

          // Update Box Summary Count
          self.updateBoxSummaryCount(qtyToAdd);

          // Update Box Summary Fill Indicator
          self.updateBoxSummaryFillIndicator(qtyToAdd, currentBoxTotalCount);

          // Update Box Summary Price
          self.updateBoxSummaryPrice(priceToAdd);

          // Check full status
          self.checkFullStatus(qtyToAdd, currentBoxTotalCount);

          // Update selected "Choose Your Pack" variant
          this.updatePackSizeSelector(currentBoxTotalCount);

          // Update box product prices
          this.updatePrices(currentBoxTotalCount);

        }

        if(parts[0] == "updating") {
          // Change Button text
          $(selectors.sectionContainer).html("Update Box");
        }

      }.bind(this));
    },

    /**
     * Toggle the qty popup for box item
     *
     */
    toggleQtyPopup: function(evt) {
      var id = evt.target.attributes['data-product-id'].value;
      var parent = $(selectors.boxItem + '[data-product-id="' + id + '"]');

      if($(selectors.qtyPopup, parent).hasClass('hide')){
        $(selectors.qtyPopup, parent).removeClass('hide');
      } else {
        $(selectors.qtyPopup, parent).addClass('hide');
      }
    },

    /**
     * Remove box item in the BAB Summary
     *
     */
    removeFromBox: function(evt) {
      var id = evt.target.attributes['data-product-id'].value;
      var parent = $(selectors.boxItem + '[data-product-id="' + id + '"]');
      var productPrice = parseInt($(parent).attr('data-product-price'));
      var qtyToSubtract = parseInt($(selectors.updateboxItemQtyText, parent).html());
      var currentBoxCount = parseInt($(selectors.boxCount).html());
      var updatedBoxCount = currentBoxCount - qtyToSubtract;
      var currentBoxTotalCount = parseInt($(selectors.boxTotalCount).html());
      var currentBoxPrice = parseInt($(selectors.boxPrice).attr('data-box-price'));

      // Update Box Summary Count
      this.updateBoxSummaryCount(updatedBoxCount);

      // Update Box Summary Fill Indicator
      this.updateBoxSummaryFillIndicator(updatedBoxCount, currentBoxTotalCount);

      // Update Box Summary Price
      var priceToSubtract = qtyToSubtract * productPrice;
      this.updateBoxSummaryPrice(currentBoxPrice - priceToSubtract);

      // Check full status
      this.checkFullStatus(updatedBoxCount, currentBoxTotalCount);

      // Update url
      this.updateHistoryState(id, 0);

      // Update toUpdate Product Array
      this.updateProductArray(productsToUpdate, id, 0);

      // Finally, remove the box item from summary
      parent.remove();
    },

    /**
     * Triggered event for empty box button
     *
     */
    triggerEmptyBox: function(evt) {
      var currentBoxTotalCount = parseInt($(selectors.boxTotalCount).html());
      var retVal = confirm("Are you sure you want to empty your box?");

      // If user agrees, empty the box.
      if(retVal == true) {
        this.emptyBox(currentBoxTotalCount);
      } else {
        return false;
      }
    },

    /**
     * Remove all line items from box summary. Zero outs other elements.
     *
     */
    emptyBox: function(currentBoxTotalCount, boxSize) {
      // Remove all line items from box items list
      $(selectors.boxItems).empty();

      // Update Box Summary Count
      this.updateBoxSummaryCount("0");

      // Update Box Summary Fill Indicator
      this.updateBoxSummaryFillIndicator("0", currentBoxTotalCount);

      // Update Box Summary Price
      this.updateBoxSummaryPrice("0");

      // Update Total Box Count if passed through
      if(boxSize) {
        $(selectors.boxTotalCount).html(boxSize);
      }

      // Update url to remove all query strings
      var id = slate.utils.getUrlParameter("id");
      var size = slate.utils.getUrlParameter("size");
      var updating = slate.utils.getUrlParameter("updating");
      var newurl = window.location.href.split(/[?#]/)[0];
      newurl = "?id=" + id + "&size=" + size;
      if(updating == "true") {
        newurl = newurl + "&updating=" + updating;
      }
      window.history.replaceState({path: newurl}, "", newurl);
    },

    /**
     * Toggle the size of box
     *
     */
    toggleBoxSize: function(evt) {
      var parent = evt.target.parentElement;
      var updatedBoxSize = evt.target.attributes['value'].value;
      var currentItemsInBox = parseInt($(selectors.boxCount).html());

      if(currentItemsInBox > 0) {

        var retVal = confirm("Switching to this quantity will remove all items in your box. Continue?");

        // If user agrees, empty the box.
        if(retVal == true) {

          this.emptyBox(updatedBoxSize, updatedBoxSize);
          // Make clicked button active
          $(selectors.toggleBoxSize).removeAttr("checked").parent('label').removeClass("c-btn--pack-size-active");
          $(parent).addClass("c-btn--pack-size-active");
          $(selectors.toggleBoxSize, parent).attr("checked", "checked");
          // Let's reassign the box a random ID
          var randomId = Math.floor(100000000 + Math.random() * 900000000);
          this.$container.attr('data-box-id', randomId);
          // Update box id
          this.updateHistoryState("id", randomId);
          // Check full status
          this.checkFullStatus(currentItemsInBox, updatedBoxSize);

        } else {

          console.log(evt.target);
          evt.target.blur();

          return false;

        }

      } else {
        // Make clicked button active
        $(selectors.toggleBoxSize).removeAttr("checked").parent('label').removeClass("c-btn--pack-size-active");
        $(parent).addClass("c-btn--pack-size-active");
        $(selectors.toggleBoxSize, parent).attr("checked", "checked");
      }

      // Update selected "Choose Your Pack" variant
      this.updatePackSizeSelector(updatedBoxSize);
      // Update box product prices
      this.updatePrices(updatedBoxSize);
      // Update url
      this.updateHistoryState("size", updatedBoxSize);
      // Update Total Box Count
      $(selectors.boxTotalCount).html(updatedBoxSize);

    },


    /**
     * Scroll to dropdown section on mobile.
     *
     */

    scrollToDropdown: function(evt) {
      if (window.innerWidth >= 950) return;

      const button = this;
      const topOffset = button.getBoundingClientRect().top;

      //change window scroll position as soon as the tabs are toggled
      const config = {attributes: true, childList: false, subTree: false};
      const cb = function(mutationsList, observer) {
        //loop through mutations
        for(const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {

            //aria-expanded changed - run code to change window scroll position
            $('html, body').scrollTop($(button).offset().top - topOffset);

            if (button.getAttribute('aria-expanded') === 'true') {
              window.setTimeout(() => {
                // scroll to set dropdown bar at 25%
                $('html, body').animate({
                  scrollTop: $(button).offset().top - (window.innerHeight * .25)
                }, 300);     
              }, 150);
            }
            
            observer.disconnect();
            //== end scroll position code ==//
          }
        }
      }

      const observer = new MutationObserver(cb);
      observer.observe(button, config);

    },


    /**
     * Update full status. If full, let's switch some things.
     *
     */
    checkFullStatus: function(updatedBoxCount, currentBoxTotalCount) {
      if(updatedBoxCount == currentBoxTotalCount) {
        $(selectors.boxIndicator).addClass("full");
        $(selectors.addToCart).removeAttr("disabled");
      } else {
        $(selectors.boxIndicator).removeClass("full");
        $(selectors.addToCart).attr("disabled", "disabled");
      }
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function(evt) {
      var productHandle = evt.target.attributes['data-product-handle'].value;
      var parent = $(selectors.product + '[data-product-handle="' + productHandle + '"]');
      var productObject = JSON.parse($(selectors.productJson, parent).html());

      var variant = this._getVariantFromOptions(parent, productObject);

      parent.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      $(selectors.addToBox, parent).attr('data-variant-id', variant.id);
    },

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function(parent) {
      var currentOptions = $.map($(selectors.singleOptionSelector, parent), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            $('.c-btn--pack-size').removeClass("c-btn--pack-size-active");
            $element.parent().addClass("c-btn--pack-size-active");

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function(parent, product) {
      var selectedValues = this._getCurrentOptions(parent);
      var variants = product.variants;

      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Buildabox;
})();

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
   * @namespace cart
 */

theme.Cart = (function() {

  var selectors = {
    referralCallout: '[data-referral-callout]',
    referralSection: '[data-referral-section]',
  };

  /**
   * Cart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Cart(container) {
    this.$container = $(container);

    var $referralCallout = $(selectors.referralCallout);
    $('a', $referralCallout).on('click', this.scrollToReferral.bind(this));
  }

  Cart.prototype = $.extend({}, Cart.prototype, {

    /**
     * Scroll To Referral Section
     *
     */
    scrollToReferral: function(evt) {
      evt.preventDefault();
      $('html, body').animate({
        scrollTop: $(selectors.referralSection).offset().top
      }, 500);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Cart;
})();

/**
 * Collection List Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the CollectionList section.
 *
   * @namespace CollectionList
 */

theme.CollectionList = (function() {

  var selectors = {
    collectionBucketLink: '[data-collection-bucket-link]'
  };

  /**
   * CollectionList section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function CollectionList(container) {
    this.$container = $(container);

    $(selectors.collectionBucketLink).on("click", function(e) {
      e.preventDefault();
      window.location = $(this).attr('data-href');
    });
  }

  CollectionList.prototype = $.extend({}, CollectionList.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return CollectionList;
})();

/**
 * Featured Products Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FeaturedProducts section.
 *
   * @namespace FeaturedProducts
 */

theme.FeaturedProducts = (function() {

  var selectors = {
    productsCarousel: '[data-products-carousel]'
  };

  /**
   * FeaturedProducts section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function FeaturedProducts(container) {
    this.$container = $(container);

    var mySwiper = new Swiper (selectors.productsCarousel, {
      slidesPerView: 1,
      spaceBetween: 30,

      navigation: {
        nextEl: '.swiper-button--next',
        prevEl: '.swiper-button--prev',
      },

      breakpoints: {
        500: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        825: {
          slidesPerView: 3,
          spaceBetween: 50,
        }
      }
    })

    // $(selectors.productsCarousel).slick({
    //   rows: 0,
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   dots: false,
    //   prevArrow: '<button type="button" class="slick-prev pull-left"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.51507 8.5L9 15.6194L7.74246 17L7.43094e-07 8.5L7.74247 -1.09937e-07L9 1.38058L2.51507 8.5Z" fill="black"/></svg></button>',
    //   nextArrow: '<button type="button" class="slick-next pull-right"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.48493 8.5L0 1.38058 1.25754 0 9 8.5 1.25754 17 0 15.6194 6.48493 8.5z" fill="#000"/></svg></button>'
    // });
  }

  FeaturedProducts.prototype = $.extend({}, FeaturedProducts.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return FeaturedProducts;
})();

/**
 * Header Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Header template.
 *
   * @namespace header
 */

theme.Header = (function() {

  var selectors = {
    siteSelector: '[data-site-selector]',
    siteSelectorLink: '.c-utility-nav__link--site',
    userCountryCode: 'country_code',
    siteSelectorCountryCode: 'site_selector',
  };

  /**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);

    // Only do the switch if we're in the US store
    // Else, update the site selector for CA
    if($('body').attr('data-locale') == "US") {
      if(slate.utils.getUrlParameter('site') == "intl") {
        Cookies.set(selectors.siteSelectorCountryCode, "INTL", { expires: 1 });
        this.updateSiteSelector("INTL");
      } else {
        // Get user location and set cookie if no cookie present
        if(!Cookies.get(selectors.siteSelectorCountryCode) || !Cookies.get(selectors.userCountryCode)) {
          this.getUserLocation();
        } else {
          this.updateSiteSelector(Cookies.get(selectors.siteSelectorCountryCode));
        }
      }
    } else if($('body').attr('data-locale') == "CA") {
      this.updateSiteSelector("CA");
    }

    if(Cookies.get(selectors.userCountryCode) == "CA" && $('body').attr('data-locale') == "US" && Cookies.get('disable_popup') != 1) {
      slate.modal.toggleModal();
    }

    $(selectors.siteSelector).on('click', this.updateCookie.bind(this));
  }

  Header.prototype = $.extend({}, Header.prototype, {

    /**
     * Get Users Location
     *
     */
    getUserLocation: function(evt) {
      _self = this;
      $.ajax({
        url: 'http://api.ipstack.com/check?access_key=9bc28baee2bd6f78a6debbd5c4128297&format=1',
        dataType: 'jsonp',
        success: function(location) {
          console.log(location);
          if(!(location.country_code == "US" || location.country_code == "CA")) {
            var siteSelectorCountryCode = "INTL";
          } else {
            var siteSelectorCountryCode = location.country_code;
          }
    			Cookies.set(selectors.userCountryCode, location.country_code, { expires: 1 });
    			Cookies.set(selectors.siteSelectorCountryCode, siteSelectorCountryCode, { expires: 1 });
          _self.updateSiteSelector(siteSelectorCountryCode);
        },
        error: function(response) {
          console.log(response);
        }
      });
    },

    /**
     * Update Site Selector
     *
     */
    updateSiteSelector: function(siteSelectorCountryCode) {
      if(siteSelectorCountryCode == "INTL") {
        var $intl = $('[data-site-selector="INTL"]');
        var $us = $('[data-site-selector="US"]');
        var intlText = $intl.html();
        var intlUrl = $intl.attr('href');
        var usText = $us.html();
        var usUrl = $us.attr('href');

        $us.html(intlText).attr('data-site-selector', 'INTL').attr('href', intlUrl);
        $intl.html(usText).attr('data-site-selector', 'US').attr('href', usUrl);
      }

      $(selectors.siteSelectorLink).css("opacity", 1);
    },

    /**
     * Update Country Code Cookie
     *
     */
    updateCookie: function(evt) {
      var siteSelectorCountryCode = evt.currentTarget.attributes['data-site-selector'].value;
      // Update country code cookie based on site selector
      if(siteSelectorCountryCode == "INTL") {
        Cookies.set(selectors.siteSelectorCountryCode, siteSelectorCountryCode, { expires: 1 });
      } else {
        Cookies.remove(selectors.siteSelectorCountryCode);
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Header;
})();

/**
 * Hero Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Hero section.
 *
   * @namespace hero
 */

theme.Hero = (function() {

  var selectors = {
    heroCarousel: '[data-hero-carousel]'
  };

  /**
   * Hero section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Hero(container) {
    this.$container = $(container);

    $(selectors.heroCarousel).slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false
    });
  }

  Hero.prototype = $.extend({}, Hero.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Hero;
})();

/**
 * Instagram Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Instagram section.
 *
   * @namespace instagram
 */

theme.Instagram = (function() {

  /**
   * Instagram section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Instagram(container) {
    this.$container = $(container);

    var feed = new Instafeed({
      accessToken: InstagramToken,
      limit: 6,
      template: '<li><a href="{{link}}" target="_blank"><img src="{{image}}" alt="{{caption}}" /></a></li>'
    });
    feed.run();
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Instagram;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCartForm: '[data-add-to-cart-form]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImageSlider: '[data-product-featured-images]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbsSlider: '[data-product-thumbnails]',
    productThumbs: '[data-product-single-thumbnail]',
    productQtyToAdd: '[data-product-qty]',
    singleOptionSelector: '[data-single-option-selector]',
    color: 'input[name="color"]',
  };


  

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    this.$container.on('variantColorChange' + this.namespace, this.updateProductImageForColor.bind(this));
    $(selectors.addToCart, this.$container).on('click', this.addToCart.bind(this));

    $(selectors.productFeaturedImageSlider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: selectors.productThumbsSlider,
      arrows: false,
      fade: true
    });

    $(selectors.productThumbsSlider).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: selectors.productFeaturedImageSlider,
      dots: false,
      focusOnSelect: true
    });

    if(slate.utils.getUrlParameter("variant")) {
      this.updateProductImage();
    }

    if($('input[name="color"]:checked').val()) {
      var evt = {};
      evt.color = $('input[name="color"]:checked').val();
      this.updateProductImageForColor(evt);
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Add items to cart via ajax
     *
     */
    addToCart: function(evt) {
      evt.preventDefault();
      var qtyToAdd = $(selectors.productQtyToAdd).val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(selectors.addToCartForm).serialize(),
        dataType: 'json',
        success: function(response) {
          console.log(response);
          slate.cart.updateCartPopup(response, qtyToAdd);
          slate.cart.toggleCartPopup();
        },
        error: function(XMLHttpRequest) {
          console.log(XMLHttpRequest);
        }
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var $productPrice = $(selectors.productPrice, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $productPrice.addClass('c-price__product-price--sale');
        // $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $productPrice.removeClass('c-price__product-price--sale');
        // $compareEls.addClass('hide');
      }
    },

    /**
     * Sets the slick slider to appropriate index
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var slide;
      if(evt) {
        var variantId = evt.variant.id;
      } else {
        var variantId = slate.utils.getUrlParameter("variant");
      }

      $(selectors.productThumbs).each(function() {
        slideIndex = parseInt($(this).closest('.slick-slide').attr('data-slick-index'));
        if($(this).attr('data-variant').indexOf(variantId) >= 0 && slideIndex >= 0) {
          slide = slideIndex;
          return false;
        }
      });

      if(slide != null && slide != $(selectors.productFeaturedImageSlider).slick('slickCurrentSlide')) {
        // Set Featured Image slider
        $(selectors.productFeaturedImageSlider).slick('slickGoTo', slide);

        // Reset slide track if there are 3 slides or less
        var numSlides = $(selectors.productThumbsSlider).children().length
        if(numSlides <= 3) {
          $(selectors.productThumbsSlider).slick('slickGoTo', 0);
        } else {
          $(selectors.productThumbsSlider).slick('slickGoTo', slide);
        }

        // Set active state for thumb image
        $('.slick-slide', selectors.productThumbsSlider).removeClass('slick-current');
        $('.slick-slide[data-slick-index="' + slide + '"]', selectors.productThumbsSlider).addClass('slick-current');
      } else {
        return false;
      }
    },

    /**
     * Sets the slick slider to appropriate index based on color
     *
     * @param {string} src - Image src URL
     */
    updateProductImageForColor: function (evt) {
      var slide;
      var color = evt.color;

      $(selectors.productThumbs).each(function () {
        slideIndex = parseInt($(this).closest('.slick-slide').attr('data-slick-index'));
        if ($(this).attr('data-color').indexOf(color) >= 0 && slideIndex >= 0) {
          slide = slideIndex;
          return false;
        }
      });

      if (slide != null && slide != $(selectors.productFeaturedImageSlider).slick('slickCurrentSlide')) {
        // Set Featured Image slider
        $(selectors.productFeaturedImageSlider).slick('slickGoTo', slide);

        // Reset slide track if there are 3 slides or less
        var numSlides = $(selectors.productThumbsSlider).children().length
        if (numSlides <= 3) {
          $(selectors.productThumbsSlider).slick('slickGoTo', 0);
        } else {
          $(selectors.productThumbsSlider).slick('slickGoTo', slide);
        }

        // Set active state for thumb image
        $('.slick-slide', selectors.productThumbsSlider).removeClass('slick-current');
        $('.slick-slide[data-slick-index="' + slide + '"]', selectors.productThumbsSlider).addClass('slick-current');
      } else {
        return false;
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Referral Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Referral section.
 *
   * @namespace referral
 */

theme.Referral = (function() {

  var selectors = {
    addToCartForm: '[data-add-to-cart-form]',
    addToCart: '[data-add-to-cart]',
    productFeaturedImageSlider: '[data-product-featured-images]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productQtyToAdd: '[data-product-qty]',
    originalSelectorId: '[data-product-select]',
    singleOptionSelector: '[data-single-option-selector]',
    referralInput: '[data-referral]',
  };

  /**
   * Referral section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Referral(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);

    $(selectors.addToCartForm, this.$container).on('submit', this.addToCart.bind(this));
  }

  Referral.prototype = $.extend({}, Referral.prototype, {

    /**
     * Add items to cart via ajax
     *
     */
    addToCart: function(evt) {
      evt.preventDefault();
      var referrals = "";
      $(selectors.referralInput, this.$container).each(function() {
        if($(this).val()) {
          referrals += $(this).val() + ", ";
        }
      });

      var variantId = this.variants.currentVariant.id
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: 'attributes[referrals]=' + referrals,
        dataType: 'json',
        success: function(response) {
          addReferralGift(variantId);
        },
        error: function(XMLHttpRequest) {
          addReferralGift(variantId);
        }
      });

      function addReferralGift(variantId) {
        var data = {
          id: variantId,
          quantity: 1,
          properties: {
            'Referral Gift': "Yes"
          }
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(response) {
            // Refresh cart page after successfully adding products and updateing referral field
            document.location.href = '/cart';
          },
          error: function(XMLHttpRequest) {
            // Refresh cart page after successfully adding products and updateing referral field
            document.location.href = '/cart';
          }
        });
      }

    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Referral;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('babCallout', theme.BabCallout);
  sections.register('buildabox', theme.Buildabox);
  sections.register('cart', theme.Cart);
  sections.register('collectionList', theme.CollectionList);
  sections.register('featuredProducts', theme.FeaturedProducts);
  sections.register('header', theme.Header);
  sections.register('hero', theme.Hero);
  sections.register('inputQuantity', theme.InputQuantity);
  sections.register('instagram', theme.Instagram);
  sections.register('product', theme.Product);
  sections.register('referral', theme.Referral);

  // Init Cart Scripts
  slate.cart.init();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));
  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Sticky Nav
  var sticky = new Waypoint.Sticky({
    element: $('[data-site-nav]')[0],
    stuckClass: 'is-stuck'
  });

  // Initialize Slick Sliders
  $('[data-megamenu-slider]').slick({
    arrows: false,
    dots: true
  });

  // Resize megamenu slider on "Shop" hover since JS can't get height and width of invisible element in DOM
  $('[data-trigger-slider-resize]').mouseover(function () {
    if ($('[data-shown-megamenu]').attr("data-shown-megamenu") == "false") {
      // Resize sliders on "Shop" hover since JS can't get height and width of invisible element in DOM
      $('[data-megamenu-slider]').slick('resize');
      $(this).attr('data-shown-megamenu', "true");
    } else {
      return false;
    }
  });

  // Toggle Mobile Menu

  $('[data-toggle-menu]').click(function (e) {
    e.preventDefault();
    if ($('[data-mobile-nav]').hasClass('is-open')) {
      $('[data-mobile-nav]').removeClass('is-open');
      $('body').removeClass('nav-is-open');
    } else {
      var announcementBarHeight = $('[data-announcement-bar]').length ? $('[data-announcement-bar]').outerHeight() : 0;
      var mobileNavheight = 'calc(100svh - ' + announcementBarHeight + 'px - ' + $('[data-site-nav]').outerHeight() + 'px)';
      $('[data-mobile-nav]').height(mobileNavheight);
      $('[data-mobile-nav]').addClass('is-open');
      $('body').addClass('nav-is-open');
    }
  });

  // Toggle Mobile Submenus
  $('[data-toggle-submenu]').click(function (e) {
    e.preventDefault();
    var submenu = $(this).attr('data-submenu');
    if ($('#' + submenu).hasClass('is-open')) {
      $('#' + submenu).removeClass('is-open');
      $(this).removeClass('is-open');
    } else {
      $('#' + submenu).addClass('is-open');
      $(this).addClass('is-open');
    }
  });

  // Initialize Magnific Popup for Videos
  $('[data-video-popup]').magnificPopup({
    type: 'iframe'
  });

  // Initialize Tabs
  ButaneTabs.init();
  // Initialize Accordions
  ButaneAccordion.init();

  // Product Card mouseover event
  $('.js-variant-btn').mouseover(function () {
    var variantID = $(this).attr('data-variant');
    var parent = $(this).closest('[data-product-card]');
    var product = JSON.parse($('[data-product-json]', parent).html());
    var index = product.variants.findIndex(function (variant) {
      return variant.id == variantID;
    });
    var variant = product.variants[parseInt(index)];
    var priceWrapper = $('[data-price-wrapper]', parent);
    var productPrice = $('[data-product-price]', parent);
    var comparePrice = $('[data-compare-price]', parent);
    var compareText = $('[data-compare-text]', parent);
    var compareEls = comparePrice.add(compareText);
    var saleBanner = $('[data-sale-banner]', parent);
    var variantImg = $("[data-variant='" + variantID + "']").attr('data-img');
    var variantUrl = $("[data-variant='" + variantID + "']").attr('data-url');

    // Update button
    $('.js-variant-btn', parent).removeClass('is-active');
    $(this).addClass('is-active');

    // Update Image
    $('.js-variant-image img', parent).attr('src', variantImg);
    $('.js-variant-image', parent).attr('href', variantUrl);

    // Update Price
    $(productPrice).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
    if (variant.compare_at_price > variant.price) {
      comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
      productPrice.addClass('c-price__product-price--sale');
      compareEls.removeClass('hide');
      saleBanner.removeClass('hide');
    } else {
      comparePrice.html('');
      productPrice.removeClass('c-price__product-price--sale');
      compareEls.addClass('hide');
      saleBanner.addClass('hide');
    }
  });

  // Close Modal
  $('[data-close-modal]').click(function (e) {
    e.preventDefault();
    slate.modal.toggleModal();
    Cookies.set('disable_popup', 1, {
      expires: 1
    });
  });

  // Custom Collection Pagination
  function get_query() {
    var url = document.location.href;
    var qs = url.substring(url.indexOf('?') + 1).split('&');
    for (var i = 0, result = {}; i < qs.length; i++) {
      qs[i] = qs[i].split('=');
      result[qs[i][0]] = decodeURIComponent(qs[i][1]);
    }
    return result;
  }
  var urlParameters = get_query();
  var numPages = $('.js-pagination-item').length;
  var paged = parseInt(urlParameters.paged);

  // handle pagination for the numbers
  if (typeof urlParameters.paged != 'undefined') {
    console.log(paged);
    $('.js-paginate-panel').hide();
    $("[data-paginate='" + paged + "']").show();
    $("[data-paginate-link='" + paged + "']").addClass('c-pagination__item--active');
  } else {
    $('.js-paginate-panel').hide();
    $("[data-paginate='1']").show();
    $("[data-paginate-link='1']").addClass('c-pagination__item--active');
    $('.js-pagination-prev').hide();
  }

  // handle pagination for the arrows
  if (urlParameters.paged == 1 || typeof urlParameters.paged == 'undefined') {
    $('.js-pagination-prev').hide();
  } else {
    var prevNav = paged - 1;
    $('.js-pagination-prev a').attr('href', '?paged=' + prevNav);
  }
  if (numPages > 1 && numPages != paged) {
    var nextNav = paged + 1;
    $('.js-pagination-next a').attr('href', '?paged=' + nextNav);
  } else {
    $('.js-pagination-next').hide();
  }
});

// fix for variant dropdowns showing even when it isn't available
function correctSizeDropdown() {
  var $checked_color_option = $('input[name="color"]:checked');
  var color_variant_id = $checked_color_option.attr('data-variant-id');
  var source = '?view=size_options&variant=' + color_variant_id;
  // console.log(source);
  if (color_variant_id != undefined) {
    $('.c-field__input--select').load(source, function () {});
  }
}
$(document.body).on('change', 'input[name="color"]', function () {
  correctSizeDropdown();
});
$(document).ready(function () {
  correctSizeDropdown();
});